import { useState } from "react";
import ImageEditor from "@/pages/profile/components/ImageEditor";

interface ImagesSectionProps {
  title: string;
  description: string;
  bucket: "avatars" | "covers";
  aspect: "square" | "wide";
  userId: string;
  currentUrl: string | null;
  onPersist: (url: string | null) => Promise<void>;
}

/**
 * Sección de ajuste de imagen (foto o portada) dentro de la configuración.
 * Abre el mismo editor modal que se usa desde el encabezado del perfil.
 */
export default function ImagesSection({
  title,
  description,
  bucket,
  userId,
  currentUrl,
  onPersist,
}: ImagesSectionProps) {
  const [open, setOpen] = useState(false);
  const type = bucket === "avatars" ? "avatar" : "cover";

  return (
    <section className="rounded-lg border border-background-200/70 bg-background-50 p-5">
      <h2 className="font-heading text-lg font-bold text-foreground-950">
        {title}
      </h2>
      <p className="mt-1 text-sm text-foreground-600">{description}</p>

      <button
        type="button"
        onClick={() => setOpen(true)}
        className="mt-4 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
      >
        <i className="ri-camera-line"></i>
        {currentUrl ? "Cambiar imagen" : "Subir imagen"}
      </button>

      <ImageEditor
        open={open}
        onClose={() => setOpen(false)}
        title={type === "avatar" ? "Editar foto de perfil" : "Editar foto de portada"}
        type={type}
        currentUrl={currentUrl}
        userId={userId}
        onSave={onPersist}
      />
    </section>
  );
}